import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Grid, Button } from '@mui/material';
import MediaQuery from 'react-responsive';
import { NavLink } from 'react-router-dom';
import PreparationCheckModal from 'components/PreparationCheckModal';
import { submissionModelName } from 'utils/contentHelper';

export class LandingPage extends React.Component {
  render() {
    const { promotion, navigateTo } = this.props;

    return (
      <React.Fragment>
        <Grid size={12} align="center">
          <MediaQuery maxWidth={767}>
            <div className="promo-banner" role="img" title={promotion.banner_mobile_alt_text || "Promo Banner"} style={{'backgroundImage': 'url("' + promotion.mobile_banner + '")'}}></div>
          </MediaQuery>
          <MediaQuery minWidth={767}>
            <div className="promo-banner" role="img" title={promotion.banner_desktop_alt_text || "Promo Banner"} style={{'backgroundImage': 'url("' + promotion.desktop_banner + '")'}}></div>
          </MediaQuery>
          {promotion && promotion.has_preparation_checks ?
            <PreparationCheckModal promotion={promotion} onSubmit={() => navigateTo('/claim')}
              openComponent={(props) =>
                <Button variant="contained" component="div" size="large" color="primary" className="claim-cta" aria-label={'Submit your ' + submissionModelName(promotion)} {...props}>
                  {promotion.competition ? 'Enter' : 'Claim'}
                </Button>
              }
            />
            :
            <Button
              component={NavLink}
              to={{pathname: '/claim', search: this.props.location.search}}
              className="claim-cta"
              variant="contained"
              size="large"
              color="primary"
              aria-label={'Submit your ' + submissionModelName(promotion)}>{promotion.competition ? 'Enter' : 'Claim'}
            </Button>
          }
        </Grid>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = {
  navigateTo: (path) => push(path)
};

export default connect(null, mapDispatchToProps)(withRouter(LandingPage));
